import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Delete, MoreHoriz} from '@mui/icons-material'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Dialog from 'components/Dialog'
import BulkUpdateContent from 'components/BulkUpdateContent'
import {
    fetchDocumentAdd,
    fetchDocumentsUpdate,
    fetchDocumentDelete,
    selectionChange
} from 'modules/collection/actions'
import RowIcon from './RowIcon'

const Bottom = styled.section`
    height: 52px;
    align-items: center;
    display: flex;
    padding: ${props => props.mobile ? '10px' : '10px 16px 10px 96px'};
    box-sizing: border-box;
    justify-content: space-between;
    background-color: #fff;
`

const Total = styled.div`
    display: flex;
    user-select: none;

    div {
        background-color: rgba(160, 183, 190, 0.24);
        color: #7c9198;
        font-weight: 400;
        border-radius: 2px;
        padding: 3px 10px;
        font-size: 13px;
    }

    div:not(:last-child) {
        margin-right: 5px;
        background: #415dd4;
        color: #FFF;
    }
`

const ButtonAdd = styled.div`
    font-size: 16px;
    color: #415dd4;
    align-items: center;
    cursor: pointer;
    display: flex;
    user-select: none;

    svg {
        min-height: 32px;
        min-width: 32px;
        margin-right: 8px;
    }
`

const Item = styled(MenuItem)`
	text-transform: uppercase;
	font-size: 12px;
	letter-spacing: 2px;
`

class TableBottom extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            openDialog: false,
            openMenu: null
        }
    }

    handleCloseDialog = () => {
        this.setState({ openDialog: false })
    }

    handleCloseMenu = () => {
        this.setState({ openMenu: null })
    }

    handleOpenMenu = (e) => {
        this.setState({ openMenu: e.currentTarget })
    }

    handleDelete = () => {
        this.props.fetchDocumentDelete(this.props.selected)
        this.setState({ openDialog: false})
    }

    clearSelection = () => {
        this.props.selectionChange([])
        this.handleCloseMenu()
    }

    handleInvertSelection = () => {
        const selected = this.props.documents.filter(document =>
            this.props.selected.findIndex(item => item === document.id) === -1).map(row => row.id)

        this.props.selectionChange(selected)
        this.handleCloseMenu()
    }

    handleCreateRecord = () => {
        this.props.fetchDocumentAdd()
        this.handleCloseMenu()
    }

    handleClickDelete = () => {
        this.setState({ openDialog: 'delete' })
    }

    handleClickUpdate = () => {
        this.setState({ openDialog: 'update' })
        this.handleCloseMenu()
    }

    documentsUpdate = (field, value) => {
        this.props.fetchDocumentsUpdate(this.props.selected, field, value)
        this.handleCloseDialog()
    }

    render() {
        const { intl, permissions, connection } = this.props

        return (
            <React.Fragment>
                <Bottom mobile={this.props.mobile}>
                    <div>
                        {!this.props.selected.length ?
                            <React.Fragment>
                                {permissions.Write && !connection &&
                                    <ButtonAdd onClick={this.handleCreateRecord}>
                                        <RowIcon />
                                        {intl.formatMessage({id: "table.add_record"})}
                                    </ButtonAdd>
                                }
                            </React.Fragment>
                            :
                            <div>
                                {permissions.Delete && !connection &&
                                    <Delete style={{ fontSize: 25, marginRight: '10px', color: '#d45b4a', cursor: 'pointer' }}
                                        onClick={this.handleClickDelete}
                                    />
                                }
                                <MoreHoriz style={{ fontSize: 25, cursor: 'pointer' }}
                                    onClick={this.handleOpenMenu}
                                />
                            </div>
                        }
                    </div>
                    <Total>
                        {!!this.props.selected.length &&
                            <div>
                                {intl.formatMessage({id: "table.selected"}, {count: this.props.selected.length})}
                            </div>
                        }
                        <div>{this.props.count !== this.props.documents.length ? this.props.documents.length + ' / ' : ''}{this.props.count} {intl.formatMessage({id: "table.total"})}</div>
                    </Total>
                </Bottom>
                <Dialog
                    fullWidth={this.state.openDialog === 'update' ? true : false}
                    open={Boolean(this.state.openDialog)}
                    onClose={this.handleCloseDialog}
                >
                {this.state.openDialog === 'update' &&
                    <BulkUpdateContent
                        entity={this.props.entity}
                        entities={this.props.entities}
                        documentsUpdate={this.documentsUpdate}
                        handleCloseDialog={this.handleCloseDialog}
                    />
                }
                {this.state.openDialog === 'delete' &&
                    <React.Fragment>
                        <DialogTitle>
                            {intl.formatMessage({id: "app.confirm_delete_title"})}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {intl.formatMessage({id: "table.confirm_delete_record_text"}, {count: this.props.selected.length})}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDialog} color="primary">
                                {intl.formatMessage({id: "app.confirm_cancel"})}
                            </Button>
                            <Button onClick={this.handleDelete} variant="contained" color="secondary">
                                {intl.formatMessage({id: "app.confirm_delete"})}
                            </Button>
                        </DialogActions>
                    </React.Fragment>
                }
                </Dialog>
                <Menu
                    anchorEl={this.state.openMenu}
                    open={Boolean(this.state.openMenu)}
                    onClose={this.handleCloseMenu}
                >
                    {permissions.Write && !connection &&
                        <Item
                            onClick={this.handleCreateRecord}
                        >
                            {intl.formatMessage({id: "table.add_record"})}
                        </Item>
                    }
                    <Item
                        onClick={this.handleInvertSelection}
                    >
                        {intl.formatMessage({id: "table.invert_selection"})}
                    </Item>
                    <Item
                        onClick={this.clearSelection}
                    >
                        {intl.formatMessage({id: "table.clear_selection"})}
                    </Item>
                    {permissions.Write &&
                        <Item
                            onClick={this.handleClickUpdate}
                        >
                            {intl.formatMessage({id: "table.bulk_update"})}
                        </Item>
                    }
                </Menu>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities, collection, login}) => ({
    entities: entities.entities,
    selected: collection.selected,
    permissions: login.permissions,
    count: collection.count,
    documents: collection.documents
})

export default connect(mapStateToProps, {
    fetchDocumentAdd,
    fetchDocumentsUpdate,
    fetchDocumentDelete,
    selectionChange
})(injectIntl(TableBottom))
